import { COLORS } from '@constants/colors';

export const useStyles = () => ({
  container: {
    backgroundColor: 'rgba(180, 50, 70, 0.95)',
    borderRadius: '8px',
    padding: '8px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  text: {
    color: COLORS.WHITE,
    fontSize: '14px',
    fontWeight: 500,
  },
  divider: {
    color: COLORS.WHITE,
    fontSize: '14px',
  },
  exitLink: {
    color: COLORS.WHITE,
    fontSize: '14px',
    fontWeight: 500,
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: '#ffcccc',
    },
  },
});
